import { render, staticRenderFns } from "./AdminWorkshopTasksScreen.vue?vue&type=template&id=32f38108&scoped=true&"
import script from "./AdminWorkshopTasksScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopTasksScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f38108",
  null
  
)

export default component.exports